import React from "react";
export const Loader = () => {
  return (
    <div className="loader">
      <div className="loader-container">
        <img
          src="../assets/LOGO_JDR.png"
          alt="loader"
          className="logo-loader"
        />
      </div>
    </div>
  );
};
